import About3D from "./About3D";
import Home3D from "./Home3D";
import "./CSS_styles/heading.css";
import "./CSS_styles/home3d.css";
import "./CSS_styles/about3d.css";
import useSectionTracker from "./useSectionTracker";
import Skills3D from "./Skills3D";
import AIFun3D from "./AIfun3D";
import Contact3D from "./Contact3D";
import Footer3D from "./Footer3D";

export default function My3DWorld({ onNameDragChange }) {
  useSectionTracker(["about", "skills", "ai-fun", "contact"]);

  return (
    <div className="world3d-page">
      <Home3D onNameDragChange={onNameDragChange} />
      <About3D />
      <Skills3D/>
      <AIFun3D />
      <Contact3D/>
      <Footer3D />
    </div>
  );
}